import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { TOOLBAR_DROPDOWN_PANEL } from "./data-hooks.js";
import classes from "./dropdown-modal-scss.js";
const DropdownModal = ({
  options,
  minWidth,
  className,
  onKeyDown,
  onCloseButtonClick,
  title
}) => {
  const { isMobile } = useContext(RicosContext);
  if (isMobile) {
    return /* @__PURE__ */ React.createElement(
      SidePanel,
      {
        closeButtonProps: { onClick: onCloseButtonClick },
        width: "100%",
        maxHeight: "50vh",
        height: "fit-content"
      },
      /* @__PURE__ */ React.createElement(SidePanel.Header, { title }),
      /* @__PURE__ */ React.createElement(SidePanel.Content, { className: classes.mobileContent }, options)
    );
  }
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(classes.root, className),
        "data-hook": TOOLBAR_DROPDOWN_PANEL,
        style: {
          "--ricos-internal-dropdown-modal-min-width": minWidth ? `${minWidth}px` : void 0
        },
        onKeyDown
      },
      options
    )
  );
};
export {
  DropdownModal
};
//# sourceMappingURL=dropdown-modal.js.map
